export const helpArea = {
  handbook: "Help articles in our help centre",
  video: "Instructions as video",
  faq: "FAQ"
};
